
<div>
    <company-edit
        v-if="company"
        class       = "mb-3"
        :height     = "469"
        :company    = "company"
        :show-store = "showStore"
        :comment-rows = "8"
        ref         = "companyEditor"
        @stored     = "onStored"
    >
        <template v-slot:additional>
            <v-row class="no-frame">
                <v-col class="no-frame">
                    <v-text-field
                        label          = "Import Name"
                        v-model        = "company.idname"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                    />
                </v-col>
            </v-row>
        </template>
        <template v-slot:roles>
            <v-row dense>
                <v-col>

                </v-col>
            </v-row>
            <v-select
                v-model    = "company.roles"
                :items     = "roles"
                :rules     = "[rules.required]"
                item-value = "id"
                item-text  = "name"
                label      = "Rollen"
                @change    = "onChangeRoles"
                return-object
                multiple
                chips
                dense
            >
                <template v-slot:item="data">
                    <div class="v-flex">
                        <div class="tag">
                            {{ data.item.label }}
                        </div>
                        <div class="pl-1">
                            {{ data.item.name }}
                        </div>
                    </div>
                </template>
                <template v-slot:selection="data">
                    <c-tag
                        :label  = "data.item.label"
                        :active = "false"
                        class   = "mr-1"
                    />
                </template>
            </v-select>
        </template>
    </company-edit>
</div>
